import { Settings } from "luxon";

// Locale Luxon par défaut : sans elle, tout `toFormat("MMMM")` sans `setLocale("fr")`
// rend les mois dans la locale du système (anglais côté serveur/CI).
// Hors Nuxt, l'équivalent vit dans test/unit/setup.ts (le projet vitest e2e, lui, frappe
// un vrai serveur qui charge ce plugin).
// Dérivée d'i18n via appLocale() ; constante tant qu'il n'y a qu'une locale (sinon un
// watch sur la locale serait requis pour réactualiser ce défaut global).
export default defineNuxtPlugin(() => {
  Settings.defaultLocale = appLocale();
});
